export default "__VITE_ASSET__CmlidJOA__"